import { Box, Skeleton } from "@mui/material";
import { useTranslation } from "react-i18next";

const CompareLoading = ({ numCandidates }: { numCandidates: number }) => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.compareCandidatesModal" });

  const skeletonRows = [
    { label: t("experience") },
    { label: t("keySkillsMatch") },
    { isSection: true, label: t("nationalityAndLocation") },
    { label: t("nationality") },
    { label: t("residenceCountry") },
    { isSection: true, label: t("submittedForm") },
    { label: t("languagesSpoken") },
    { label: t("willingToRelocate") },
    { label: t("submittedVideo") },
    { label: t("anyMajorInjury") },
    { label: t("clubsAcademiesWorkedIn") },
  ];

  return (
    <Box sx={styles.gridContainer(numCandidates)}>
      {/* Header row skeleton */}
      <Box sx={styles.rowLabelCell} />
      {Array.from({ length: numCandidates }).map((_, i) => (
        <Box key={`header-skel-${i}`} sx={styles.userDataCellSkeleton}>
          <Skeleton variant="circular" width={50} height={50} />
          <Skeleton variant="text" width="80%" />
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="rounded" width="100%" height={32} />
        </Box>
      ))}

      <Box sx={styles.rowSectionTitleCell}>{t("overview")}</Box>

      {skeletonRows.map((row, rowIndex) =>
        row.isSection ? (
          <Box key={`section-${rowIndex}`} sx={styles.rowSectionTitleCell}>
            {row.label}
          </Box>
        ) : (
          <>
            <Box key={`label-${rowIndex}`} sx={styles.rowLabelCell}>
              {row.label}
            </Box>
            {Array.from({ length: numCandidates }).map((_, i) => (
              <Box key={`cell-${rowIndex}-${i}`} sx={styles.valueCellSkeleton}>
                <Skeleton variant="text" width="60%" />
              </Box>
            ))}
          </>
        )
      )}
    </Box>
  );
};

export default CompareLoading;

const styles = {
  gridContainer: (numCandidates: number) => ({
    display: "grid",
    gridTemplateColumns: `256px repeat(${numCandidates}, 164px)`,
    gap: "32px",
    maxHeight: "100%",
    overflowY: "auto",
    pr: "16px",
  }),
  rowSectionTitleCell: {
    fontFamily: "Montserrat",
    color: "var(--Brand-700, #076D0D)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    gridColumn: "1 / -1",
    mt: 2,
  },
  rowLabelCell: {
    fontFamily: "Montserrat",
    color: "var(--Gray-700, #344054)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
  },
  userDataCellSkeleton: {
    width: "164px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid var(--Gray---100, #E7E7E7)",
  },
  valueCellSkeleton: {
    display: "flex",
    justifyContent: "center",
  },
};
